import Swiper from 'swiper/bundle'

export const initReviews = () => {
  document.querySelectorAll('.reviews-slider').forEach(section => {
    const el = section.querySelector('.js-reviews-swiper')
    // Lives above the footer, outside the async page area, so only build it once
    if (!el || el.swiper) return

    const swiper = new Swiper(el, {
      slidesPerView: 1.1,
      spaceBetween: 16,
      grabCursor: true,
      navigation: {
        prevEl: section.querySelector('.js-reviews-prev'),
        nextEl: section.querySelector('.js-reviews-next'),
      },
      breakpoints: {
        600: { slidesPerView: 2, spaceBetween: 24 },
        1000: { slidesPerView: 3, spaceBetween: 30 },
      },
    })

    // Only show "Read more" on reviews that are actually cut off (checked again when the screen size changes)
    const texts = section.querySelectorAll('.js-review-text')
    const checkCutOff = () => texts.forEach(text => {
      const button = text.parentElement.querySelector('.js-review-more')
      if (button && !text.classList.contains('is-expanded')) {
        button.hidden = text.scrollHeight <= text.clientHeight + 1
      }
    })

    texts.forEach(text => {
      const button = text.parentElement.querySelector('.js-review-more')
      if (!button) return

      button.addEventListener('click', () => {
        const expanded = text.classList.toggle('is-expanded')
        button.textContent = expanded ? 'Read less' : 'Read more'
        button.setAttribute('aria-expanded', expanded)
        swiper.update()
      })
    })

    checkCutOff()
    window.addEventListener('resize', checkCutOff)
  })
}
